import Image from 'next/image'

export const categoryIconMap: Record<string, React.ReactNode> = {
    'Изображения': (
        <Image 
            src='/subscription/svg-icons/image-icon.svg' 
            width={20} 
            height={20} 
            alt='Изображения'
        />
    ),
    'Чат-боты': (
        <Image 
            src='/subscription/svg-icons/text-icon.svg' 
            width={20} 
            height={20} 
            alt='Чат-боты'
        />
    ),
    'Видео': (
        <Image 
            src='/subscription/svg-icons/video-icon.svg' 
            width={20} 
            height={20} 
            alt='Видео'
        />
    ),
    'Музыка': (
        <Image 
            src='/subscription/svg-icons/audio-icon.svg' 
            width={24} 
            height={21} 
            alt='Музыка'
        />
    ),
}

